export default "__VITE_ASSET__3627527e__"